/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
"use strict"

import angular from "angular"

const systemThemeResolver = (ApiSrv, $rootScope) => {
  if ($rootScope.systemTheme !== undefined) {
    return Promise.resolve($rootScope.systemTheme)
  }

  return ApiSrv.getCustomUiTheme()
    .then((themeData) => {
      const theme = themeData?.val ?? null
      $rootScope.systemTheme = theme
      return theme
    })
    .catch((_err) => {
      $rootScope.systemTheme = null
      return null
    })
}

angular.module("uCountitUiApp").config(function ($stateProvider) {
  $stateProvider.state("login", {
    url: "/login?returnUrl",
    templateUrl: "app/account/login/login.html",
    controller: "LoginCtrl",
    resolve: {
      systemTheme: systemThemeResolver,
    },
  })

  return $stateProvider
    .state("recovery", {
      url: "/account/recovery",
      templateUrl: "app/account/recovery/recovery.html",
      controller: "RecoveryCtrl",
      resolve: {
        systemTheme: systemThemeResolver,
      },
    })
    .state("app.profile", {
      url: "/profile",
      templateUrl: "app/account/profile/profile.html",
      controller: "ProfileCtrl",
      authenticate: true,
    })
})
